import React from 'react';
export function UniqueMechanism() {
  return <section className="bg-forest-900 py-20 px-4" data-id="element-218">
      <div className="max-w-4xl mx-auto" data-id="element-219">
        <div className="text-center mb-12" data-id="element-220">
          <h2 className="text-3xl md:text-5xl font-bold text-white" data-id="element-221">
            En muchísimos casos, cuando hay síntomas compatibles, la causa puede
            ser{' '}
            <span className="text-gold-400 block mt-2" data-id="element-222">
              SIBO (sobrecrecimiento bacteriano en el intestino delgado).
            </span>
          </h2>
        </div>

        <div className="bg-forest-800 p-8 md:p-12 rounded-3xl shadow-xl border border-forest-800/50 mb-12 text-white" data-id="element-223">
          <p className="text-lg md:text-xl leading-relaxed mb-6" data-id="element-224">
            Bacterias que deberían estar en el intestino grueso terminan
            fermentando comida donde no deben… y ahí aparecen gases e hinchazón.
          </p>
          <p className="text-xl md:text-2xl font-bold text-gold-400" data-id="element-225">
            No se trata de fuerza de voluntad: se trata de orden y estrategia.
          </p>
        </div>
      </div>
    </section>;
}